import React from 'react';
import { StudyGuideMyGuideDataGrid } from './study-guide-my-guide-data-grid';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';

export function StudyGuideMyGuideModal(props) {
  const { data } = props;

  return (
    <DialogContent size="lg">
      <DialogTitle>Interação com o guia</DialogTitle>

      <StudyGuideMyGuideDataGrid
        data={data}
        height={366}
      />
    </DialogContent>
  );
}
